import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './page/Navbar';
import Footer from './page/Footer';
import KolkataEstates from './page/Kolkataestates';
import DubaiEstates from './page/DubaiEstates';
import About from './page/About';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<KolkataEstates />} />
            <Route path="/about" element={<About />} />
            <Route path="/dubai" element={<DubaiEstates />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;